import $ from "../../libs/jquery-3.3.1.min.js"
import {gsap, PixiPlugin} from "../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import 'pixi.js/advanced-blend-modes';

// Constructor
export class BaseMiniGame extends PIXI.Application {

  constructor(data) {
    super();
    this.data = data;
    this.assets = {};
    this.fonts = {};

    this.appWidth = 500;
    this.appHeight = 500;

    // Language switchers texts
    this.interfaceTextFR = [];
    this.interfaceTextEN = [];

    // Update game interface language
    $(document).on('i18nFlip i18nSet', (e) => {
      this.interfaceLanguageSwitch(e.lang);
    });
  }

  async init(target) {
    PixiPlugin.registerPIXI(PIXI);

    const domTarget = (typeof target == "string") ? $(target).get(0) : target;
    $(domTarget).width(this.appWidth + "px")
    $(domTarget).height(this.appHeight + "px")

    await super.init({
      width: this.appWidth,
      height: this.appHeight,
      // TODO: Remove background color and set alpha 0 when ready
      // backgroundColor: 0x000000,
      backgroundAlpha: 0,
      resolution: window.devicePixelRatio || 1,
      antialias: true,
      canvas: domTarget,
      // NEEDS TO BE TRUE FOR WEBGL TO WORK WITH BLENDMODES!
      // useBackBuffer: true,
    });

    return this;
  }

  // To be overridden in subclasses
  async buildStage() {
  }

  // To be overridden in subclasses
  reset() {
  }

  async assetLoader() {
    // To be completed in subclasses
    if (this.data.global && this.data.global.fonts && this.data.global.fonts.length) {
      for (let i = 0; i < this.data.global.fonts.length; i++) {
        this.fonts[this.data.global.fonts[i].name] = await PIXI.Assets.load({
          alias: this.data.global.fonts[i].name,
          src: this.data.global.fonts[i].url,
          data: {
            family: this.data.global.fonts[i].family,
            style: this.data.global.fonts[i].style,
            weights: this.data.global.fonts[i].weights,
          }
        });
      }
    }
  }

  complete() {
    console.log("COMPLETE");
    this.dispatchEvent(new CustomEvent("complete", {detail: "C'est complété."}))
  }

  dispatchEvent(...args) {
    this.canvas.dispatchEvent(...args)
  }

  on(...args) {
    this.canvas.addEventListener(...args);
  }

  /**
   * Create text element
   * Used later for translating the game interface
   * @param text
   * @param style
   * @param lang
   * @returns {Text}
   */
  createInterfaceText(text, style, lang) {
    // Create new text
    const newText = new PIXI.Text({
      text: text,
      style: style,
    });

    // Hidden by default
    newText.alpha = 0.0;

    // Add text to array, used later for language switcher
    if (lang === "en") {
      this.interfaceTextEN.push(newText);
    } else if (lang === "fr") {
      this.interfaceTextFR.push(newText);
    }

    return newText;
  }

  /**
   * Create HTML text element
   * Used later for translating the game interface
   * @param text
   * @param style
   * @param lang
   * @returns {Text}
   */
  createInterfaceHTMLText(text, style, lang) {
    // Create new text
    const newText = new PIXI.HTMLText({
      text: text,
      style: style,
    });

    // Hidden by default
    newText.alpha = 0.0;

    // Add text to array, used later for language switcher
    if (lang === "en") {
      this.interfaceTextEN.push(newText);
    } else if (lang === "fr") {
      this.interfaceTextFR.push(newText);
    }

    return newText;
  }

  /**
   * Language switcher for interface text
   * Show/Hide using language
   * @param lang
   */
  interfaceLanguageSwitch(lang) {
    const textShownArray = lang === "fr" ? this.interfaceTextFR : this.interfaceTextEN;
    const textHiddenArray = lang === "fr" ? this.interfaceTextEN : this.interfaceTextFR;

    // Update hidden
    textHiddenArray.forEach(text => text.alpha = 0.0);

    // Update shown
    textShownArray.forEach(text => text.alpha = 1.0);
  }
}
